import React, { useEffect, useState } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';

export default function TenderView({ PAYMENT_MODES, orderTypeNum, orderId, onPaymentModeChange, onTenderSelect }) {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    const [availablePaymentModes, setAvailablePaymentModes] = useState([]);
    const [selectedTender, setSelectedTender] = useState("");

    useEffect(() => {
        if (orderTypeNum) fetchConfiguredPaymentMode();
    }, [orderTypeNum]);

    const fetchConfiguredPaymentMode = async () => {
        try {
            const response = await callAPI(`${apiUrls.CONFIGURED_PAYMENT_MODE}?order_type=${orderTypeNum}`, {}, 'GET');
            const data = response.data.data || {};
            const modes = [];

            if (data.is_cash_enabled) modes.push(PAYMENT_MODES.cod);
            if (data.is_eftpos_enabled) modes.push(PAYMENT_MODES.eftpos);
            if (data.is_online_enabled && orderTypeNum !== 3) modes.push(PAYMENT_MODES.online);

            setAvailablePaymentModes(modes);
            selectDefaultPaymentMode(modes);
        } catch (error) {
            console.error('Error fetching configured payment mode:', error);
        }
    };

    const selectDefaultPaymentMode = (modes) => {
        if (modes.includes(PAYMENT_MODES.eftpos)) {
            selectPaymentMethod(PAYMENT_MODES.eftpos, true);
        } else if (modes.length > 0) {
            selectPaymentMethod(modes[0], true);
        }
    };

    const selectPaymentMethod = (method, force = false) => {
        if (!force && !availablePaymentModes.includes(method)) return;
        setSelectedTender("");
        setSelectedPaymentMethod(method);
        onPaymentModeChange(method);
    };

    const selectTender = (tender) => {
        setSelectedPaymentMethod(PAYMENT_MODES.outofsystem);
        setSelectedTender(tender);

        onTenderSelect({
            paymentMethod: PAYMENT_MODES.outofsystem,
            selectedTender: tender,
        });
    };

    return (
        <div className="col-lg-auto">
            <div className="choosePaymentTrigger">

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.cod ? 'active' : ''} 
                                ${!availablePaymentModes.includes(PAYMENT_MODES.cod) ? 'disabled' : ''}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.cod)}
                >
                    <svg width="36" height="30"><use xlinkHref="./images/sprite.svg#iconCash"/></svg>
                    <span className="paymentText">Cash</span>
                </button>

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.eftpos ? 'active' : ''} 
                                ${!availablePaymentModes.includes(PAYMENT_MODES.eftpos) ? 'disabled' : ''}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.eftpos)}
                >
                    <svg width="44" height="30"><use xlinkHref="./images/sprite.svg#iconCard"/></svg>
                    <span className="paymentText">Debit Card</span>
                </button>

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.online ? 'active' : ''} 
                                ${!availablePaymentModes.includes(PAYMENT_MODES.online) ? 'disabled' : ''}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.online)}
                >
                    <svg width="30" height="30"><use xlinkHref="./images/sprite.svg#iconQr"/></svg>
                    <span className="paymentText">ONLINE</span>
                </button>

                
                <button
                    className={`${selectedTender === 'doordash' ? 'active' : ''}`}
                    onClick={() => selectTender('doordash')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Doordash</span>
                </button>

                
                <button
                    className={`${selectedTender === 'ubereats' ? 'active' : ''}`}
                    onClick={() => selectTender('ubereats')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Uber Eats</span>
                </button>

                
                <button
                    className={`${selectedTender === 'menulog' ? 'active' : ''}`}
                    onClick={() => selectTender('menulog')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Menulog</span>
                </button>

            </div>
        </div>
    );
}
